import { DomUtil } from "@/shared/ui/Helper";

export class DomUtils {
    public static scrollTo($element: JQuery) {
        const additionalOffset = $("#kt_header").height() + 10; // additional offset needed because otherwise header is covering fields
        const fieldOffset = $element.offset().top - additionalOffset;
        DomUtil.scrollTo($("html, body"), fieldOffset);
    }
}
